import proprietaryModelForFilter from '@/mixins/proprietary-model-for-filter';
import { CHANNELS_FILTER_TRANSLATE } from '@/store/modules/cards/constants';
import { isTikTok } from '@/utils/channels';
import EventBus from '@/utils/event-bus';

export default {
  mixins: [
    proprietaryModelForFilter,
  ],
  data() {
    return {
      alertMessage: this.$t('mixins.pagesModel.alert.alertMessage'),
      linkText: this.$t('mixins.pagesModel.alert.linkText'),
      linkReference: 'https://stilingue.com.br/termo-de-uso-do-dashboards-by-studio-stilingue',
    };
  },
  computed: {
    pagesFormatted() {
      if (!this.pages) {
        return [];
      }

      const channelsFiltered = [];

      if (this.card?.control) {
        const cardControlEntries = Object.entries(this.card.control);

        cardControlEntries.forEach((channelInfo) => {
          if (channelInfo[0] in CHANNELS_FILTER_TRANSLATE && Boolean(channelInfo[1]?.hideInChannel)) {
            channelsFiltered.push(CHANNELS_FILTER_TRANSLATE[channelInfo[0]]);
          }
        }
        );

        const filterByPage = this.pages.filter((page) => {
          return !page.channel.includes(channelsFiltered);
        });

        return filterByPage.map(page => ({
          text: page.title,
          value: page.id,
          channel: page.channel,
          username: page.username,
          id: page.page_id,
        }));
      }

      return this.pages.map(page => ({
        text: page.title,
        value: page.id,
        channel: page.channel,
        username: page.username,
      }));
    },
    allUniqueChannels() {
      return Array.from(new Set(this.pagesFormatted.map(page => page.channel)));
    },
    tikTokPages() {
      return [...this.pages.filter(page => isTikTok(page.channel)).map(({ id }) => id)];
    },
    pagesSelected: {
      get() {
        return this.tempFilter.pages || { value: [] };
      },
      set(newValue) {
        const newPages = newValue ? newValue.value : [];
        if (!newPages || !newPages.length) {
          delete this.tempFilter.channels;
          delete this.tempFilter.pages;

          this.channels = [];
          return;
        }

        const pageChannels = [];
        newPages.forEach(newPageId => {
          const foundPage = this.pages.find(page => page.id === newPageId);
          if (foundPage) {
            pageChannels.push(foundPage.channel);
          }
        });

        const channels = Array.from(new Set(pageChannels));
        this.tempFilter.channels = {
          value: channels,
        };
        this.channels = channels;

        const ids = Array.from(new Set(newPages));
        this.tempFilter.pages = {
          value: ids,
        };
      },
    },
  },
  methods: {
    isTikTokPagesSelected(pages) {
      if (Boolean(pages.length)) return pages.some(page => this.tikTokPages.includes(page));
      return pages.value.some(page => this.tikTokPages.includes(page));
    },
    isSentimentThemeTagSelected(filter) {
      return Boolean(filter?.polarities?.value?.length) ||
        Boolean(filter?.tags?.value?.length) ||
        Boolean(filter?.themes?.value?.length);
    },
    validateTikTok(items) {
      if (Boolean(items.length)) EventBus.$emit('clearTikTokPages');
    },
  },
};
